module.exports = __webpack_public_path__ + "static/media/logowordmark.8670e885.png";